import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=1f5b34a0&scoped=true&"
var script = {}
import style0 from "./Home.vue?vue&type=style&index=0&id=1f5b34a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5b34a0",
  null
  
)

component.options.__file = "Home.vue"
export default component.exports